import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLButton } from "OLButton";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";
import { useState } from "react";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    calendar: {
      width: "320px",
      backgroundColor: theme.white50,
      padding: theme.spacing(12, 16, 0, 16),
      display: "flex",
      flexWrap: "wrap",
    },
    day: {
      width: 36,
      height: 36,
      fontSize: 14,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "1px solid transparent",
      borderRadius: "8px",
      cursor: "pointer",
    },
    buttonWrapper: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(12),
      borderTop: `1px solid ${theme.gray200}`,
      width: "100%",
      padding: theme.spacing(3),
    },
    selected: {
      backgroundColor: theme.primary500,
      color: theme.white00,
    },
    btn: {
      padding: theme.spacing(3, 4),
    },
  }),
);

interface Props {
  cancel: () => void;
  apply: (days: number[]) => void;
  dayOfMonth: number[];
}

export const Calendar = ({ cancel, apply, dayOfMonth }: Props) => {
  const [selectedDays, setSelectedDays] = useState(dayOfMonth);
  const classes = useStyles();
  const { message } = useMessage();
  const days = Array.from({ length: 31 }, (_, i) => i + 1);

  const toggleDay = (day: number) => {
    const days = [...selectedDays];
    const selected = days.findIndex((selectedDay) => selectedDay === day);
    const isSelected = selected > -1;

    if (isSelected) {
      days.splice(selected, 1);
    } else {
      days.push(day);
    }

    return setSelectedDays(days.sort((a, b) => a - b));
  };

  return (
    <>
      <div className={classes.calendar}>
        {days.map((day) => {
          const isSelected = !!selectedDays.find(
            (selectedDay) => selectedDay === day,
          );

          return (
            <div
              onClick={() => toggleDay(day)}
              className={`${classes.day} ${isSelected ? classes.selected : ""}`}
            >
              {day}
            </div>
          );
        })}
      </div>
      <div className={classes.buttonWrapper}>
        <OLButton className={classes.btn} onClick={cancel}>
          {message({ id: "cancel" })}
        </OLButton>
        <OLButton className={classes.btn} onClick={() => apply(selectedDays)}>
          {message({ id: "save" })}
        </OLButton>
      </div>
    </>
  );
};
